import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Button,
  Avatar,
  Select,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Tooltip
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button,
  left_flex_box
} from "../../app/components/Styles";
import { BrandSelect } from "../../app/components/BrandSelect";
import { isMobile } from "react-device-detect";
import { Image, Table } from "antd";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { getProducts, getWarehouses, downloadInboundsQRS, getVendors, getInbounds } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline, DownloadOutlined } from "@mui/icons-material";
import moment from "moment/moment";
import InboundsTable from "../../app/components/InboundsTable";

export const ApprovalInboundsList = ({
  getProducts,
  getWarehouses,
  downloadInboundsQRS,
  getVendors,
  getInbounds,
  inbounds,
  user,
  vendors,
  warehouses,
  products,
  isLoading
}) => {
  const navigate = useNavigate();
  const [vendorId, setVendorId] = React.useState(null);
  const [page, setPage] = React.useState(1);

  useEffect(() => {
    getInbounds({ page, limit: 100, status: "Pending Approval" })
  }, [page])

  useEffect(() => {
    if(page === 1){
      getInbounds({ page, limit: 100, vendorId, status: "Pending Approval" })
    } else {
      setPage(1)
    }
  }, [vendorId])

  useEffect(() => {
    getVendors({ page: 1, limit: 1000 })
  }, [])

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Inbounds Awaiting Approval</Typography>
        </Box>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Box sx={{ ...left_flex_box }}>
                <BrandSelect
                  vendors={vendors}
                  value={vendorId}
                  label="Filter by Vendor"
                  emptyLabel="All vendors"
                  autoFocus
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  onChange={(id) => setVendorId(id)}
                />
              </Box>
            </CardContent>
          </Card>
        </Box>
        
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  products: state?.records?.productInbounds,
  vendors: state?.records?.vendors,
  warehouses: state?.records?.warehouses?.docs,
  inbounds: state?.records?.inbounds
});

const mapDispatchToProps = { getInbounds, getWarehouses, getVendors, downloadInboundsQRS };

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalInboundsList);
